import { Text } from '@hg/stylizator/typography'
import { Spacing } from '@hg/stylizator/utils'
import parse from 'html-react-parser'
import * as React from 'react'
import { IWPGBlock } from 'react-gutenberg'

const WPGParagraphBlock: React.FC<IWPGBlock & { attrs: { className?: string } }> = (props) => {
  return (
    <Spacing top={3} className={props.attrs?.className ?? ''}>
      <Text type="body" useCompact>
        {parse(props.innerHTML)}
      </Text>
    </Spacing>
  )
}

export default WPGParagraphBlock
